import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./FloatingContact.css";

export default function FloatingContact() {
  return (
    <a
      href="https://wa.me/528718977732"
      target="_blank"
      rel="noopener noreferrer"
      className="contact-fab"
      aria-label="Contactar por WhatsApp"
    >
      <FaWhatsapp size={24} />
    </a>
  );
}
